import { Alert, Box, Typography } from '@mui/material';

export default function AlertBox(props) {
  const { severity = 'info', content, sx } = props;

  return (
    <Box sx={{ overflowY: 'auto', width: '100%', ...sx }}>
      <Alert severity={severity}>
        <Typography>{content}</Typography>
      </Alert>
    </Box>
  );
}
